/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo,useEffect } from 'react';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { MSBService, PolicyService, UserService } from 'gw-capability-gateway';
import {
    GatewayBillingService,
    GatewayPaymentService,
} from 'gw-capability-gateway-billing';
import metadata from './PolicySummary.metadata.json5';
import PolicyDetailsAccordion from "../../components/TFPAPolicyDetailsAccordion/PolicyDetailsAccordion.jsx";
import PropertyDetailsAccordion from "../../components/TFPAPropertyDetailsAccordion/PropertyDetailsAccordion.jsx";
import ConstructionDetailsAccordion from "../../components/TFPAConstructionDetailsAccordion/ConstructionDetailsAccordion.jsx";
import DiscountSurchargesLossAccordion from "../../components/TFPADiscountSurchargesLossAccordion/DiscountSurchargesLossAccordion.jsx";
import CoveragesAccordion from "../../components/TFPACoveragesAccordion/CoveragesAccordion.jsx";
import TFPADocumentsAccordion from '../../components/TFPADocumentsAccordion/TFPADocumentsAccordion.jsx';
import TFPAContactsAccordion from '../../components/TFPAContactsAccordion/TFPAContactsAccordion.jsx';
import messages from "./PolicySummary.messages.js"
import styles from "./PolicySummary.module.scss"

const PolicySummary = props => {
    const {
        onTabChangeObj,
        jobNumber
    } = props;

    const { authHeader } = useAuthentication();

    useEffect(() => {
        //   getPaymentSummaryByPolicyNumber()
       // getUrlAndOpen()
    }, [])

    const getPaymentSummaryByPolicyNumber = () => {
        const result = GatewayBillingService.getPaymentSummaryByPolicyNumber(onTabChangeObj.latestJobPolicyPeriod.policyNumber, authHeader)
    }

    const getUrlAndOpen = useCallback(() => {
        if(onTabChangeObj){
            const urlPromise = MSBService.getReviewMSBUrl(onTabChangeObj.latestJobPolicyPeriod.policyNumber, authHeader);
            return urlPromise
        }
    },[authHeader, onTabChangeObj]);

    const yesNo = useCallback((boolVal) => {
        const result = boolVal ? 'Yes' : 'No'
        return result
    }, []);

    const getDocumentTitle = useCallback(()=>{
        if(onTabChangeObj){
        return <span>Documents{`(${onTabChangeObj.latestJobPolicyPeriod.documentDTOs.length})`}</span>
        }
    },[onTabChangeObj])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        policyDetailsSection: {
            onTabChangeObj
        },
        propertyDetailsSection: {
            onTabChangeObj,
            getUrlAndOpen,
            yesNo
        },
        constructionDetailsSection: {
            onTabChangeObj,
            yesNo
        },
        discountSurchargesLossSection: {
            onTabChangeObj,
            yesNo
        },
        coveragesDetailsSection: {
            onTabChangeObj
        },
        documentsDetailsSection:{
            onTabChangeObj,
            jobNumber
        },
        documentsDetailsAccordion:{
            title: getDocumentTitle()            
        },
        contactsDetailsSection:{
            onTabChangeObj
        }
    };



    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        },
        resolveComponentMap: {
            policyDetailsComponent: PolicyDetailsAccordion,
            propertyDetailsComponent: PropertyDetailsAccordion,
            constructionDetailsComponent: ConstructionDetailsAccordion,
            discountSurchargesLossAccordion: DiscountSurchargesLossAccordion,
            coveragesDetailsComponent: CoveragesAccordion,
            documentDetailsComponent: TFPADocumentsAccordion,
            contactDetailsComponent: TFPAContactsAccordion
        }
    };




    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            //model={submissionVM}
            // onModelChange={updateWizardData}
            // onValueChange={writeValue}
            // showErrors={showErrors}
            // onValidationChange={setComponentValidation}
            // callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
};

PolicySummary.propTypes = wizardProps;
PolicySummary.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
};
export default withAuthenticationContext(withRouter(PolicySummary));
